import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysUntil',
})
export class DaysUntilPipe implements PipeTransform {
  transform(targetDate: string): string {
    if (!targetDate) return '';

    const today = new Date();
    const target = new Date(targetDate);

    if (target < today) {
      return 'Lejárt';
    }

    let yearDiff = target.getFullYear() - today.getFullYear();
    let monthDiff = target.getMonth() - today.getMonth();
    let dayDiff = target.getDate() - today.getDate();

    if (dayDiff < 0) {
      monthDiff--;
      const previousMonth = new Date(
        target.getFullYear(),
        target.getMonth(),
        0,
      );
      dayDiff += previousMonth.getDate();
    }

    if (monthDiff < 0) {
      yearDiff--;
      monthDiff += 12;
    }

    const parts: string[] = [];

    if (yearDiff > 0) {
      parts.push(`${yearDiff} év`);
    }

    if (monthDiff > 0) {
      parts.push(`${monthDiff} hónap`);
    }

    if (dayDiff > 0) {
      parts.push(`${dayDiff} nap`);
    }

    return parts.length ? parts.join(' ') : 'Ma jár le';
  }
}
